import React, { useEffect, useState, useContext} from "react";
import { format, toInt} from '../Utils';
import moment from 'moment';
import {UserService} from '../Services/UserService';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid, TextField, Typography, Divider } from "@material-ui/core";
// import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
// import MomentUtils from '@date-io/moment';
import { Autocomplete } from "@material-ui/lab";
import { RouteService } from "../Services/RouteService";
import { DashboardContext } from "../DashboardContext";
import Block from "./Block";
import DragItem from "../DragItem";
import queryString from 'query-string';

const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    }
}));

export default function DeliverySequencePlanner(props){

    const { blocks, setBlocks, moveItem } = useContext(DashboardContext);
    const classes = useStyles();
    const [agents, setAgents] = useState([]);
    const date = moment();
    const [hasChanges, setHasChanges] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [message, setMessage] = useState(undefined);
    const [reSelection, setReSelection] = useState(false);
    const [generate, setGenerate] = useState(false);

    useEffect(() => {

        let agent = undefined;
        if(props.location.search){
            let qString = queryString.parse(props.location.search);
            if(qString.agent){
                agent = qString.agent;
            }
        }

        props.setTitle('Store Delivery Sequence Planner');
        props.isLoading(true);
        UserService.getAgentList()
        .then((data) => {
            console.log(data);
            setAgents(data.users);
            if(agent){
                let agentObj = data.users.find(u => u.id === agent);
                if(agent){
                    setSelectedAgent(agentObj);
                    setGenerate(true);
                }
            }
            props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            props.isLoading(false);
        });
        return () => {
            
        }
    }, [true]);

    React.useEffect(() => {

        if(generate && selectedAgent && selectedAgent.id){
            setBlocks([]);
            setGenerate(false);
            setHasChanges(false);
            props.isLoading(true);
            RouteService.getStoreDeliveriesForAgent(selectedAgent.id, date.startOf('d').format(format))
            .then((data) => {
                console.log(data);
                if(data.length > 0){
                    setBlocks(data.filter(s => s.sort_order !== toInt(99999)).sort((first, second) => first.sort_order - second.sort_order));
                    setHasChanges(true);
                    setMessage(undefined);
                } else {
                    setMessage('No Routes Assigned');
                }
                props.isLoading(false);
                setReSelection(false);
            })
            .catch(error => {
                console.log(error);
                props.isLoading(false);
                setMessage('Something went wrong. Please try again.')
            });
        }
    }, [generate])

    // const handleChangeStart = (date) => {
    //     setDate(date);
    // }

    const save = () => {
        props.showProgressDialog();
        setHasChanges(false);
        let body = {};
        body.stores = blocks.map((p, i) => ({
            store_id: p.store_id,
            sort_order: i,
            route_id: p.route_id,
            route_name: p.route_name
        }));
        body.agent_name = selectedAgent.name;

        RouteService.saveOrderV2({'user-id' : props.user.id, 'user-name': props.user.name }, body)
        .then(() => {
            props.isLoading(false);
            setReSelection(true);
            props.showSnackBar(`Order Saved`, 'success');
            props.closeProgressDialog();
        })
        .catch(() => {
            props.isLoading(false);
            setHasChanges(true);
            props.showConfirmDialog("Failed to save Order. Please try again.", undefined, undefined);
            props.closeProgressDialog();
        });
    }

    const handleSelection = (e, agent) => {
        setSelectedAgent(agent);
        setReSelection(true);
    }
    
    return (
        <div className="Home agent_report" style={{marginTop: 32}}>
            <Paper style={{paddingTop: 8, paddingBottom: 8, minHeight: '80vh'}}>
                <Grid container style={{paddingLeft: 8, paddingRight: 8}}>
                    <Grid item xs={12} lg={4} style={{marginTop: 16}}>
                        <Autocomplete
                            id="agent-selection"
                            disableClearable
                            options={agents}
                            getOptionLabel={option => (option && option.name) || ''}
                            value={selectedAgent || null}
                            required={true}
                            onChange={handleSelection}
                            className={classes.autoCompleteSelectionTextField}
                            style={{ zIndex: 9999 }}
                            renderInput={params => (
                                <TextField {...params} label="Select Agent" variant="outlined" fullWidth />
                            )}
                            />
                    </Grid>
                    {/* <Grid item xs={6} lg={2}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    margin="normal"
                                    label="From"
                                    value={date}
                                    onChange={handleChangeStart}
                                    format={format_date_only}
                                    maxDate={moment().add(2, 'days')}
                                    className={classes.formControl}
                                    InputLabelProps={{
                                        style: { zIndex: 'auto' }
                                    }}
                                />
                        </MuiPickersUtilsProvider>
                    </Grid> */}
                    <Grid item xs={12} lg={4} style={{marginTop: 24}}>
                        <Button variant="outlined" disabled={!reSelection} style={{marginRight: 8}} onClick={(e) => setGenerate(true)}>Fetch Schedule</Button>
                        <Button variant="contained" color="primary" disabled={!hasChanges} onClick={save}>Save Order</Button>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Divider style={{marginTop: 16, marginBottom: 8}}/>
                </Grid>
                <Grid container item xl={12} lg={12} xs={12} spacing={0} justify={"flex-start"}>
                    {
                        blocks.map((d, index) => (
                            <DragItem key={d.store_id} id={d.store_id} onMoveItem={moveItem}>
                                <Block data={d} index={index + 1}/>
                            </DragItem>
                        ))
                    }
                </Grid>
                {
                    message && (
                    <Grid item xl={12} lg={12} xs={12}>
                        <div style={{marginTop: 50, marginBottom: 50}}>
                            <Typography variant="subtitle1" color="error">
                                {message}
                            </Typography>
                        </div>
                    </Grid>
                )}
            </Paper>
        </div>
    );
}